// extracted by mini-css-extract-plugin
export default {"payhead":"payment_payhead__vf1qR"};